import {
  getLegacyAlertsFilters,
  getLegacyAlertsListHeader,
  getLegacyAlertsTabs,
  hasAlertsTabPermission,
} from "../config/alertsModuleCatalog";
import { getLayoutSection, getPageTitleKey } from "./moduleLayoutUtils";

function resolveTabLabel(widget, t) {
  return t(widget.labelKey || widget.tabKey);
}

export function buildAlertsTabsFromLayout(layout, { t, features }) {
  const tabSection = getLayoutSection(layout, "alertsTabBar");
  if (!tabSection?.widgets) return null;

  return tabSection.widgets
    .map((widget) => ({
      tabKey: widget.tabKey,
      labelKey: widget.labelKey || widget.tabKey,
      metricKey: widget.metricKey,
      permission: widget.permission || null,
      order: typeof widget.order === "number" ? widget.order : 0,
    }))
    .filter((tab) => tab.tabKey)
    .filter((tab) => hasAlertsTabPermission(tab.tabKey, tab.permission, features))
    .sort((a, b) => a.order - b.order)
    .map((tab) => ({
      tabKey: tab.tabKey,
      labelKey: tab.labelKey,
      metricKey: tab.metricKey,
      label: resolveTabLabel(tab, t),
    }));
}

export function buildAlertsFiltersFromLayout(layout) {
  const filterSection = getLayoutSection(layout, "filterBar");
  if (!filterSection?.widgets) return null;

  return filterSection.widgets.map((widget) => ({
    id: widget.id,
    type: widget.type,
    labelKey: widget.labelKey,
    filterKey: widget.filterKey,
    visibleOnTab: widget.visibleOnTab || null,
    options: Array.isArray(widget.options)
      ? widget.options.map((option) => ({
          value: option.value,
          labelKey: option.labelKey,
        }))
      : undefined,
  }));
}

export function buildAlertsListHeaderFromLayout(layout) {
  const headerSection = getLayoutSection(layout, "alertListHeader");
  if (!headerSection?.widgets) return null;

  return headerSection.widgets.map((widget) => ({
    id: widget.id,
    type: widget.type,
    labelKey: widget.labelKey,
    placeholderKey: widget.placeholderKey,
    showCount: widget.showCount,
    pageSize: widget.pageSize,
    sortKey: widget.sortKey,
    actions: Array.isArray(widget.actions)
      ? widget.actions.map((action) => ({
          actionKey: action.actionKey,
          labelKey: action.labelKey,
          permission: action.permission || null,
        }))
      : undefined,
    options: Array.isArray(widget.options)
      ? widget.options.map((option) => ({
          value: option.value,
          labelKey: option.labelKey,
        }))
      : undefined,
  }));
}

export { getPageTitleKey, getLegacyAlertsTabs, getLegacyAlertsFilters, getLegacyAlertsListHeader };
